function  AboutDescript(){
    return(
        <>
        <div className="p-8  marginPlus bgC">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-200  mb-6">À propos de nous</h1>

            <p className="text-gray-200 ">Ce site est une procédure qui vous permettra de comprendre les fonctionnalités des étapes à suivre en tant qu'étudiant Kenyan, sur le plan éducationnel, économique et social. </p>
<p className="mt-10 text-gray-200" >Nos informations, sont des suivies de différents plans, qui vous donneront une vision sur vos envies, vos ambitions, vos désirs sur ce que vous cherchez à comprendre et voulez
Toute vos questions et préoccupations pourront être éclairçis en avance.
N'hésitez pas à poser des questions sur le lieu demandé.</p>
<p className="mt-10 text-gray-200">
Le système éducatif kenyan regorge de richesses et d'opportunités. En choisissant détudier au Kenya, vous entrez dans un environnement académique dynamique, principalement anglophone, qui figure parmi les meilleurs du continent africain.
</p> 
<p className="mt-10 text-gray-200">Le pays accueilli au moins par an plus dune centaine d'étudiant, venues de tout les coins de l'Afrique, et leurs universités n'ont font pas exception publics tout comme privés .
C'est bien plus qu'un simple choix d'études : c'est une décision qui vous ouvre les portes d'un avenir prometteur, dans un pays reconnu pour la qualité de son enseignement et de ses institutions. Ce site vous accompagne dans chaque étape de ce parcours, pour que votre projet devienne une réalité.
Les procédures importantes à retenir sont simples
</p>
 className="mt-5  text-gray-200"
<p className="mt-10 text-gray-200" >1. Visa étudiant et documents nécessaires et le type de visa à demander 
(Passeport, lettre dadmission, etc...) le processus dobtention et le temps dattente
les renouvellements et conditions de séjour.
<br/>
2 Logement étudiant et indemnité, logement sur campus (internat)) appartements à louer (seul ou en colocation) studios privés pour étudiants, prix moyens, avantages et inconvénients de chaque option
<br/>
3. Procédure d'inscription universitaire, <p className="mt-5  text-gray-200">Comment choisir une université ?</p> <p className="mt-5  text-gray-200"> Quels documents préparer ?</p>
<p className="mt-5  text-gray-200"> Comment postuler (en ligne ou en personne)</p> <p className="mt-5  text-gray-200">  Délai et frais à prévoir</p>
Avant de continuer, merci de vous fier à My Kenya Student Process Nous sommes à l'insu de votre procédure, des votre départ jusqu'à sa fin.
Nous vous guideront pas à pas afin que vous puissiez recueillir de toute les informations nécessaires et que cette expérience vous soit de plus agréable.
Pour ce début, des informations de vous nous seront utiles pour une meilleure continuation et communication
Sexe:
 
Nom:
 
Post-nom:
 
Prénom:
 
Adresse email:
 
Merci de continue avec nous
</p  >
        </div>


        <section className="py-16 bgC reveal dark:bg-gray-800 mb-10 from-green-600 to-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl font-bold mb-6">Tout ce que vous devez savoir pour étudier au Kenya offert par le service My Kenya Student Process</h2>
          <p className=" mb-8 max-w-3xl mx-auto">
            Explorez nos ressources complètes et préparez-vous pour une expérience d'études inoubliable.
          </p>
          <div className="flex  flex-wrap justify-center gap-4">
            <a href="/mksp/guide/university"
              
              
              className="bg-gray-900 rounded border dark:bg-green-700 dark:text-gray-100 text-gray-100 hover:bg-green-700 text-base px-8 py-3 h-auto"
            >
              Explorer les universités
            </a>
            <a href="/mksp/guide"
              
              
              className="border-white bg-green-700 rounded dark:bg-green-700 dark:text-gray-100 text-white hover:bg-green-500 text-base px-8 py-3 h-auto"
            >
              Consulter le guide premium
            </a>
          </div>
        </div>
      </section>
        </>
    )
} 

export default AboutDescript